import { makeStyles } from "@fluentui/react-components";

export const useOpsGenieIconStyles = makeStyles({
    root: {
        height: "24px",
        width: "24px",
        fill: "none"
    }
});
